var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSpamCount = function SvgSpamCount(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "spam",
    transform: "translate(-670.97)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_278",
    "data-name": "Rectangle 278",
    width: 24,
    height: 24,
    transform: "translate(670.97)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "report_FILL0_wght300_GRAD-25_opsz20",
    d: "M178.264-778.019a.605.605,0,0,0,.436-.169.569.569,0,0,0,.177-.429.605.605,0,0,0-.169-.436.569.569,0,0,0-.429-.177.605.605,0,0,0-.436.169.569.569,0,0,0-.177.429.605.605,0,0,0,.169.436A.569.569,0,0,0,178.264-778.019Zm0-2.412a.534.534,0,0,0,.387-.16.52.52,0,0,0,.163-.386v-4.316a.523.523,0,0,0-.159-.381.519.519,0,0,0-.382-.16.527.527,0,0,0-.385.16.519.519,0,0,0-.161.381v4.316a.531.531,0,0,0,.157.386A.512.512,0,0,0,178.267-780.431Zm-2.308,5.7a1.411,1.411,0,0,1-.525-.1,1.355,1.355,0,0,1-.463-.315l-3.285-3.308a1.416,1.416,0,0,1-.3-.456,1.36,1.36,0,0,1-.11-.532v-4.6a1.41,1.41,0,0,1,.1-.525,1.355,1.355,0,0,1,.316-.463l3.285-3.285a1.355,1.355,0,0,1,.463-.315,1.41,1.41,0,0,1,.525-.1h4.625a1.41,1.41,0,0,1,.525.1,1.355,1.355,0,0,1,.463.315l3.285,3.285a1.355,1.355,0,0,1,.315.463,1.41,1.41,0,0,1,.1.525v4.625a1.41,1.41,0,0,1-.1.525,1.355,1.355,0,0,1-.315.463l-3.308,3.285a1.415,1.415,0,0,1-.456.3,1.36,1.36,0,0,1-.532.11Zm-.124-1.087h4.883l3.466-3.476v-4.883l-3.494-3.466h-4.86l-3.471,3.471v4.883ZM178.271-781.729Z",
    transform: "translate(504.729 793.729)",
    fill: "#f59064"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpamCount, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/spamCount.cae8a798.svg";
export { ForwardRef as ReactComponent };